// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_rMH","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_RV1 StatelessWorkCardsUpsellModal-styles-cls1_rMH"};